module.exports = __webpack_public_path__ + "static/media/reception.d086d999.svg";